export class HRGoalKPI {
    id:                   string;
    hrConfigId:           string;
    hrGoalId:             string;
    ownerEmployeeId:      string;
    title:                string;
    description:          string;
    weight:               number;
}